export default "__VITE_ASSET__DGTjcE9Q__"